import type HttpClient from "../../tastyworks/http"
import {
  parseSingleResponse,
  type SingleResponse,
} from "../../tastyworks/response"
import { PASSKEY_DESER } from "../../tastyworks/user"

export class PasskeyService {
  private readonly passkeysClient: HttpClient

  constructor(userMeClient: HttpClient) {
    this.passkeysClient = userMeClient.nested("passkeys")
  }

  readonly index = async () =>
    this.passkeysClient.indexSimple(PASSKEY_DESER.toParser())

  readonly registrationBegin = async (): Promise<
    SingleResponse<PublicKeyCredentialCreationOptionsJSON>
  > => {
    const helper = await this.passkeysClient.postJson("registration", {})
    return parseSingleResponse(
      helper,
      (data) => data.toJson() as PublicKeyCredentialCreationOptionsJSON
    )
  }
}
